module.exports = __webpack_public_path__ + "static/media/firma_marcelo_bellini.e6fcf660.webp";